import {Link} from "react-router-dom"
import { Tooltip,Button,Select } from "antd";
import { volcano, green, gold, red, blue, geekblue } from "@ant-design/colors";
import {defaultColorPrimary} from "../config/AppConfig"

export function ButtonCustom({
    icon,
    onClick,
    color,
    children,
    loading,
    disabled,
    size,
    fullWidth,
    tooltip,
    type = "secondary",
    width,
    block = false,
  }) {
    if (!size) size = "middle";
    if (!loading) loading = false;
    if (!disabled) disabled = false;
    if (!block) block = false; 
  
    let style = {};
    if (color === "green")
      style = { backgroundColor: defaultColorPrimary, borderColor: defaultColorPrimary ,color:"white"};
    else if (color === "volcano")
      style = { backgroundColor: "#92989a", borderColor: "#92989a",color:"white" };
    else if (color === "gold")
      style = { backgroundColor: gold.primary, borderColor: gold.primary };
    else if (color === "red")
      style = { backgroundColor: red.primary, borderColor: red.primary };
    else if (color === "blue")
      style = { backgroundColor: blue.primary, borderColor: blue.primary }; 
    else if (color === "warning")
      style = { backgroundColor: "#ffe65cff", borderColor: "#f0cc00ff" };
    else if (color === "bronce")
      style = { backgroundColor: "#BD8A4F", borderColor: "#BD8A4F", color:"white" };
    else if (color === "geekblue")
      style = {
        backgroundColor: geekblue.primary,
        borderColor: geekblue.primary,
      }; 
    
    if (disabled) style.color = "#d0d0d0";
    if (!width) style.width = !fullWidth ? "90%" : "100%";
    else if (width) style.width = width;
  
    return (
      <Tooltip title={tooltip} placement="top">
        <Button 
          type={type}
          size={size}
          icon={icon}
          style={style}
          loading={loading}
          onClick={onClick}
          disabled={disabled}
        >
          {children}
        </Button>
      </Tooltip>
    );
  }

export function ButtonCustomLink({
    link,
    icon,
    color,
    children,
    loading,
    disabled,
    size,
  }) {
    return (
      <Link to={link}>
        <ButtonCustom
          color={color}
          icon={icon}
          loading={loading}
          disabled={disabled}
          size={size}
        >
          {children}
        </ButtonCustom>
      </Link>
    );
  }
  export function ButtonIcon({
    tooltip,
    icon,
    onClick,
    color,
    size,
    transparent,
    tooltipPlacement,
    loading = false,
    disabled = false,
  }) {
    if (!onClick) onClick = () => {};
    let style = {};
    if (color === "green")
      style = { color: green.primary, borderColor: green.primary };
    else if (color === "volcano")
      style = { color: volcano.primary, borderColor: volcano.primary };
    else if (color === "gold")
      style = { color: gold.primary, borderColor: gold.primary };
    else if (color === "red")
      style = { color: red.primary, borderColor: red.primary };
    else if (color === "blue")
      style = { color: blue.primary, borderColor: blue.primary };
    else if (color === "geekblue")
      style = { color: geekblue.primary, borderColor: geekblue.primary };
    if (!size) size = "small";
    if (transparent) style.borderColor = "transparent";
    return (
      <Tooltip title={tooltip} placement={tooltipPlacement || "right"}>
        <Button
          style={style}
          type="ghost"
          shape="circle"
          size={size}
          icon={icon}
          onClick={onClick}
          loading={loading}
          disabled={disabled}
        />
      </Tooltip>
    );
  }

  export function SearchSelect({ onChange, dataset, value, disabled, mode,placeholder="Selecciona una opción" }) {
    let tooltip = "";
    let style = { width: "100%" };
  
    if (!value) value = null;
    else {
      tooltip = dataset.find((el) => el.id === value);
      tooltip = tooltip ? tooltip.data : "";
    }
  
    if (!onChange) onChange = (value) => {
      return value;
    };
  
    return (
      <Tooltip title={tooltip}>
        <Select
          mode={mode ? mode : false}
          disabled={disabled}
          allowClear
          showSearch
          placeholder={placeholder}
          optionFilterProp="children"
          onChange={onChange}
          value={value}
          style={style}
        >
          {dataset.map((element) => {
            return (
              <Select.Option
                key={element.id}
                title={element.data}
                value={element.id}
              >
                {element.data}
              </Select.Option>
            );
          })}
        </Select>
      </Tooltip>
    );
  }

  export function PrimaryButton({
    children,
    icon,
    loading,
    size,
    fullWidth,
    disabled,
    onClick,
  }) {
    let primaryStyle = {
      backgroundColor: defaultColorPrimary,
      borderColor: defaultColorPrimary,
    };
  
    primaryStyle.width = !fullWidth ? "90%" : "100%";
    if (!size) size = "middle";
    if (!loading) loading = false;
  
    const otherProps = {};
    if (onClick) otherProps.onClick = onClick;
    return (
      <Button
        htmlType="submit"
        type="primary"
        size={size}
        loading={loading}
        icon={icon}
        style={primaryStyle}
        disabled={disabled}
        {...otherProps}
      >
        {children}
      </Button>
    );
  }